import { createSelector } from 'reselect';
import { getSearchQuery } from 'shared/selectors/search';
import { getVideoIdsByPageNumber, getIsFetching, } from 'widget/redux/client/lazy-channel-videos/selectors';
export var getIsSearchResultEmpty = createSelector([getIsFetching, getSearchQuery, getVideoIdsByPageNumber], function (isVideosFetching, searchQuery, videoIdsByPageNumber) {
    return Boolean(!isVideosFetching && searchQuery && !videoIdsByPageNumber.length);
});
